import { FieldsData, GroupFieldType, GroupSubField } from "../../types";

type SerializedFieldValue = string | number | readonly string[] | null;
type SerializedGroupValue = Record<string, SerializedFieldValue>;
type EditableInputField = Extract<
  FieldsData | GroupSubField,
  { editable: true; inputType: "text" | "number" | "select" | "date" }
>;

export function processFieldValue(
  field: EditableInputField,
): SerializedFieldValue {
  if (field.inputType === "date") {
    if (!field.value) {
      return null;
    } else if (field.inputProps?.formatResultValue) {
      return field.inputProps.formatResultValue(field.value);
    }
    return field.value.toISOString();
  } else if (field.inputType === "number") {
    return field.value ? Number(field.value) : null;
  } else if (field.inputType === "select") {
    const value = field.inputValue ?? field.value;
    if (value) {
      const inputValueNum = Number(value);
      return !isNaN(inputValueNum) ? inputValueNum : value;
    }
    return null;
  }
  return field.value ?? null;
}

export function processGroupField(
  field: GroupFieldType,
  originalGroupValue: SerializedGroupValue | null,
): { groupValue: SerializedGroupValue; hasChanges: boolean } {
  const groupValue: SerializedGroupValue = {};
  let hasChanges = false;

  if (field.inputProps?.fields) {
    // Collect current values for visibleWhen checks
    const currentValues: Record<string, unknown> = {};
    field.inputProps.fields.forEach((sf: GroupSubField) => {
      if (sf.editable && sf.inputName) {
        currentValues[sf.inputName] = sf.inputValue ?? sf.value;
      }
    });

    field.inputProps.fields.forEach((subField: GroupSubField) => {
      if (subField.editable && subField.inputName) {
        // Skip sub-fields hidden by visibleWhen
        if (subField.visibleWhen && !subField.visibleWhen(currentValues)) {
          return;
        }

        groupValue[subField.inputName] = processFieldValue(subField);

        // Check if this sub-field changed
        const originalValue = originalGroupValue?.[subField.inputName];
        if (
          groupValue[subField.inputName]?.toString() !==
          originalValue?.toString()
        ) {
          hasChanges = true;
        }
      }
    });
  }

  return { groupValue, hasChanges };
}
